import _ from 'lodash';

class TimeCounter {
    constructor(cb) {
        this.items=[];
        this.skel={
            ranges:[],
            total:0,
        };
        this.eps=15;
        this.total=0;
        this.tick=_.throttle(this.doTick.bind(this),10000);
        this.cb=cb;
        window.timeCounterReset=()=>this.update({items:[],total:0});
    }
    sanitize(tc){
        tc.total=parseInt(tc.total);
        for (var i = 0; i < tc.items.length; i++) {
            let item=tc.items[i];
            item.total=parseInt(item.total);
            for (var j = 0; j < item.ranges.length; j++) {
                let r=item.ranges[j];
                r[0]=parseFloat(r[0]);
                r[1]=parseFloat(r[1]);
            }
        }
    }
    update(t,tc){
        this.sanitize(tc);
        this.items=_.cloneDeep(tc.items);
        this.total=tc.total;
        this.cb(t,{total:this.total,items:this.items});
    }
    merge(ranges) {
        var result = [], last;
        ranges.forEach(function (r) {
            if (!last || r[0] > last[1])
                result.push(last = r);
            else if (r[1] > last[1])
                last[1] = r[1];
        });
        return result;
    }
    doTick(id,t){
        let item=_.find(this.items,{id:id});
        if (!item) {
            item=_.cloneDeep(this.skel);
            item.id=id;
            this.items.push(item);
        }
        let isNewRange=true;
        let total=0;
        for (var i = 0; i < item.ranges.length; i++) {
            let r=item.ranges[i];
            if (t>=r[0] && t<=r[1]) {
                isNewRange=false;
            }
            if (t<r[0] && t>=r[0]-this.eps) {
                r[0]=t;
                isNewRange=false;
            }
            if (t>r[1] && t<=r[1]+this.eps) {
                r[1]=t;
                isNewRange=false;
            }
        }
        if (isNewRange) {
            item.ranges.push([t,t]);
        }
        //sort ranges
        item.ranges.sort((a, b) => a[0]-b[0] || a[1]-b[1] );
        //merge ranges
        item.ranges=this.merge(item.ranges);
        item.ranges.map(r => total+=r[1]-r[0] );
        item.total=Math.round(total);
        //update total counter
        let counterTotal=0;
        this.items.map(item => counterTotal+=item.total );
        this.total=counterTotal;
        this.cb(t,{total:this.total,items:this.items});
    }
}
export default TimeCounter;
